import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  SlDrawer,
  SlInput,
  SlIcon,
  SlOption,
  SlSelect,
} from "@shoelace-style/shoelace/dist/react";
import AsyncSelect from "react-select/async";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {
  roles,
  langoptions,
  NewspaperDistrictEditonAdformats,
  NewspaperMainEditonAdformats,
  capitalizeFirstLetter,
} from "../../utils/constants";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Datepicker from "react-tailwindcss-datepicker";
import NoImage from "../../assets/images/NoImage.png";
import EditIcon from "../../assets/images/edit_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import filterSvg from '../../assets/images/filter.svg';
import LocationSVG from "../../assets/images/location.svg";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { setBirdViewRejectFilters } from "../../redux/counterSlice";
import { debounce, debouncePromise } from "../../utils/Debounce";
function BirdViewReject() {
  const dispatch = useDispatch();
  const [flag, setFlag] = useState("");
  const [show, setShow] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [advDetails, setAdvDetails] = useState();
  const [preview, setPreview] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const [dateRange, setDateRange] = useState({
    startDate: today,
    endDate: today,
  });

  const [open, setOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [adType, setAdType] = useState("Finite");
  const [selectedBrandType, setSelectedBrandType] = useState("0");
  const [newspapers, setNewspapers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [newspaperLocations, setNewspaperLocations] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  // const [merge, setMerge] = useState(false);
  const [brands, setBrands] = useState([]);
  const [imgUrl, setImgUrl] = useState("");
  const [editions, setEditions] = useState([]);
  const observer = useRef();
  const [infLoader, setInfLoader] = useState(false);
  const [newspaperData, setNewsPaperData] = useState([]);
  const [imgSrc, setImgSrc] = useState(NoImage);
  const [originalUrl, setOriginalUrl] = useState("");
  const [showOriginal, setShowOriginal] = useState(false);
  const [category, setCategory] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
    isSubmitting,
    reset,
  } = useForm();
  const watchEdition = watch("edition");
  const watchLanguage = watch("language");
  const watchAdFormat = watch("ad_format");
  const watchNewspaperName = watch("newspaper_name");
  const watchBrandType = watch("brand_type");
  const watchLocation = watch("location");
  const pageNameLower = watchEdition?.value
    ? watchEdition?.value.toLowerCase()
    : "";
  const isMain = pageNameLower.includes("main");
  const isDistrict = pageNameLower.includes("district");
  const AdFormatOptions = isMain
    ? NewspaperMainEditonAdformats
    : isDistrict
    ? NewspaperDistrictEditonAdformats
    : NewspaperMainEditonAdformats;

  const searchFilterOnChange = (e) => {
    setSearch(e.target.value);
    setData([]);
    setCurrentPage(0);
  };
  const getBrandsAlias = async (checker) => {
    try {
      if (!checker) return [];
      let requestObj = { search: checker, brand_type: watchBrandType };
      const brandsResult = await api({
        url: "user/sales_persons/getBrands",
        method: "POST",
        responseType: "json",
        data: requestObj,
      });
      if (brandsResult?.code === 200) {
        // setBrandsList(brandsResult.data)
        return brandsResult.data;
      } else return [];
    } catch (error) {
      console.error("Error @ getBrands", error);
    }
  };
  const debouncedGetBrands = debouncePromise(getBrandsAlias, 500);

  const handleDateRange = (selectedDate) => {
    setData([]);
    setCurrentPage(0);
    if (selectedDate) {
      if (selectedDate.startDate && selectedDate.endDate) {
        setDateRange(selectedDate);
      } else {
        setDateRange({ startDate: null, endDate: null });
      }
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const fetchNewsPapers = async () => {
    try {
      let res = await api({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleClose = () => {
    reset();
    setShow(false);
    setSubmit(false);
    setShowOriginal(false);
    setValue("edition", null);
    reset({edition:null, locaion:null})
    setRejectReason("")

  };
  const loadData = async (
    search = "",
    page = 0,
    selectedLocation,
    dateRange,
    adType,
    selectedNewspaper,
    userType
  ) => {
    try {
      if (
        localStorage.getItem("role") === roles.b2b ||
        localStorage.getItem("role") === roles.salesperson
      ) {
        if (data?.length === 0) {
          setLoader(true);
        } else setInfLoader(true);
        const response = await api({
          url: `/birdviewreject/get`,
          method: "POST",
          responseType: "json",
          data: {
            BirdViewSearch: search,
            page,
            BirdViewSource: selectedLocation.length
              ? selectedLocation.map((item) => item.value)
              : [],
            dateRange,
            adType,
            selectedNewspaper: selectedNewspaper.length
              ? selectedNewspaper.map((item) => item.value)
              : [],
            selectedBrandType: +selectedBrandType,
            limit: 20,
          },
        });
        if (response?.code === 200) {
          setData([...data, ...response?.data?.res]);
          setTotalRecords(response?.data?.totalCount);
          setLoader(false);
          setInfLoader(false);
    setRejectReason("")

        } else {
          toast.error(response?.data?.message);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  const loadLocations = async () => {
    // if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) && adType === "District") {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        // url: `/birdview/birdviewLocations`,
        url: `/birdview/brandsLocations`,
        method: "POST",
        responseType: "json",
      });
      if (response?.code === 200) {
        setLocations([...response?.data?.result]);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };
  const getEstimatedValue = async (
    language,
    edition,
    ad_format,
    newspaper_name,
    location
  ) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const locationValues = Array.isArray(location) ? location.map(l => l?.value) : [];
      const response = await api({
        url: `/birdview/estimatedvalue`,
        method: "POST",
        responseType: "json",
        data: {
          lang_id: language,
          edition: edition,
          ad_format: ad_format,
          newspaper_name: newspaper_name,
          location: locationValues.length ? locationValues : undefined
        },
      });
      if (response?.code === 200) {
        setValue("estimated_value", response?.data?.result?.estimated_value);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadNewspapers();
      loadEditions();
      loadBrands();
      loadNewspaperLocations();
    }
    fetchNewsPapers();
    return () => {
      dispatch(
        setBirdViewRejectFilters({
          search: "",
          selectedLocation: [],
          dateRange: {
            startDate: today,
            endDate: today,
          },
          adType: "finite",
          selectedNewspaper: [],
        })
      );
    };
  }, []);
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadLocations();
    }
  }, [adType]);

  const loadNewspapers = useCallback(async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_names`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setNewspapers(response?.data?.result);
      } else {
        toast.error(response?.data?.message);
      }
    }
  }, []);

  const loadBrands = useCallback(async () => {
    try {
      if (
        localStorage.getItem("role") === roles.b2b ||
        localStorage.getItem("role") === roles.salesperson
      ) {
        const response = await api({
          url: `/birdview/birdview_brands`,
          method: "POST",
          responseType: "json",
        });
        if (response?.code === 200) {
          setBrands(response?.data?.result);
        } else {
          toast.error(response?.data?.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  const loadNewspaperLocations = useCallback(async (language, edition) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_locations`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language, edition: edition },
      });
      if (response?.code === 200) {
        setNewspaperLocations(response?.data?.result);
      } else {
        toast.error(response?.data?.message);
      }
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      getEstimatedValue(
        watchLanguage?.value,
        watchEdition?.value,
        watchAdFormat?.label,
        watchNewspaperName?.value,
        watchLocation
      );
    }
  }, [
    watchLanguage?.value,
    watchEdition?.value,
    watchAdFormat?.label,
    watchNewspaperName?.value,
    watchLocation
  ]);

  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };
  const getColors = (brand) => {
    brand = capitalizeFirstLetter(brand);
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
      backgroundColor: brandLookup[0]?.background_color,
      color: brandLookup[0]?.color,
    };
  };
  const handleShow = async (choose, item) => {
    if (choose === "edit") {
      setValue("date", formatDateYYYYMMDD(item?.date));
      setValue("cate");
      setValue(
        "language",
        langoptions.find((option) => option.value === item?.language)
      );
      setValue(
        "newspaper_name",
        newspapers.find(
          (option) =>
            option.value === capitalizeFirstLetter(item?.newspaper_name)
        )
      );
      setValue("page_no", item.page_no);
      setValue(
        "edition",
        editions.find(
          (option) =>
            option.value.toLowerCase() === (item?.edition).toLowerCase()
        )
      );
      setValue(
        "location",
        newspaperLocations?.find((option) => +option.value === +item?.location)
      );
      setValue(
        "ad_format",
        AdFormatOptions.find((option) => option.label === item?.ad_format)
      );
      setValue("estimated_value", item.estimated_value);
      setValue("campaign_name", item.campaign_name);
      console.log(item?.brand_name);
      setValue(
        "brand_name",
        brands.find(
          (option) =>
            option.label?.split(" (")[0]?.toLowerCase() ===
            item?.brand_name?.toLowerCase()
        )?.value
      );
      setValue(
        "brand_type",
        item?.brand_type === "finite"
          ? "finite"
          : item?.brand_type === "infinite"
          ? "infinite"
          : "others"
      );
      setImgUrl(item?.image_url);
      setOriginalUrl(item?.original_url);
      setCategory(item?.category)
      setUpdateId(item?.id);
      setShow(true);
      await getEstimatedValue(
        item?.language,
        item.edition,
        item.ad_format,
        item.newspaper_name,
        item.location
      );
    }
  };
  const lastItemRef = useCallback(
    (node) => {
      if (loader) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (data?.length < totalRecords) {
            setCurrentPage((prevPage) => prevPage + 1);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    [loader]
  );
  const loadEditions = useCallback(async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_editions`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setEditions(response?.data?.result);
      } else {
        toast.error(response?.data?.message);
      }
    }
  }, []);
  const onSubmit = async (data) => {
    try {
      let res = await api({
        url: `/birdview/addai`,
        method: "POST",
        responseType: "json",
        data: {
          ad_format: data?.ad_format?.label,
          brand_name: data?.brand_name,
          brand_type: data?.brand_type?.value,
          campaign_name: data?.campaign_name,
          date: data?.date,
          edition: data?.edition?.value,
          estimated_value: data.estimated_value,
          language: data?.language?.value,
          newspaper_name: data?.newspaper_name?.value,
          page_no: data?.page_no,
          location: data?.location?.value,
          upload_url: imgUrl,
          original_url: originalUrl,
          category: category,
          id:updateId,
        },
      });
      if (res?.code === 200) {
        handleClose();
        reset();
        setFlag("");
        setData([])
        setCurrentPage(0);
        loadData(search, 0, selectedLocation, dateRange, adType, selectedNewspaper);
        setImgUrl("");
        setOriginalUrl("");
        setShowOriginal(false);
        Toast("success", "Birdview Added Successfully");
        
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Something went Wrong");
    }
  };
  const onReject = async () => {
    try {
      let res = await api({
        url: `/birdview/reject`,
        method: "POST",
        responseType: "json",
        data:{
          id:updateId,
          reason:rejectReason
        }
      });
      if (res?.code === 200) {
        handleClose();
        reset();
        setFlag("");
        setData([])
        setCurrentPage(0);
        loadData(search, 0, selectedLocation, dateRange, adType,selectedNewspaper,selectedBrandType);
        setImgUrl("");
        setOriginalUrl("");
        setShowOriginal(false);
        Toast("success", "Birdview Rejected Successfully");
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Something went Wrong");
    }
  }
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadData(
        search,
        0,
        selectedLocation,
        dateRange,
        adType,
        selectedNewspaper,
        selectedBrandType
      );
      dispatch(
        setBirdViewRejectFilters({
          search,
          selectedLocation,
          dateRange,
          adType,
          selectedNewspaper,
          selectedBrandType,
        })
      );
    }
  }, [
    search,
    selectedLocation,
    dateRange,
    adType,
    selectedBrandType,
    selectedNewspaper,
  ]);

  useEffect(()=>{
    if(currentPage !== 0){
      loadData(
        search,
        currentPage,
        selectedLocation,
        dateRange,
        adType,
        selectedNewspaper
      );
    }
  },[currentPage])

  useEffect(() => {
    setValue("location", []);
    setValue("cluster", []);
  }, [watchLanguage, watchEdition]);

  return (
    <>
      <div className={`flex gap-2 justify-end my-2 items-center stickyFilters`}>
        <div className="flex gap-4 justify-end mobHide">
          <div>
            <Select
              className=""
              placeholder="Select Newspaper"
              name="source"
              size="medium"
              value={selectedNewspaper}
              onChange={(selected) => {
                setSelectedNewspaper(selected || []);
                setData([]);
                setCurrentPage(0);
              }}
              options={[
                ...newspaperData
                  .filter((item) => item.name !== "Way2news")
                  .map((item) => {
                    return { label: item.name, value: item.name };
                  }),
              ]}
              isMulti
            />
          </div>
          <div>
            <Select
              className=""
              placeholder="Select Location"
              name="source"
              size="medium"
              value={selectedLocation}
              onChange={(selected) => {
                setSelectedLocation(selected || []);
                setData([]);
                setCurrentPage(0);
              }}
              options={[...locations]}
              isMulti
            />
          </div>
          <div>
            <SlSelect
              className="w-40"
              placeholder="Select Ad Type"
              name="adType"
              size="medium"
              value={adType}
              onSlChange={(e) => {
                setAdType(e.target.value);
                setData([]);
                setCurrentPage(0);
              }}
            >
              <SlOption key={0} value={"Finite"}>
                Finite
              </SlOption>
              <SlOption key={1} value={"Infinite"}>
                Infinite
              </SlOption>
            </SlSelect>
          </div>
          <div>
            <SlSelect
              className="w-40"
              placeholder="Select Brand Type"
              name="adType"
              size="medium"
              value={selectedBrandType}
              onSlChange={(e) => {
                setSelectedBrandType(e.target.value);
                setData([]);
                setCurrentPage(0);
              }}
            >
              <SlOption key={0} value={"0"}>
                All
              </SlOption>
              <SlOption key={1} value={"1"}>
                National
              </SlOption>
              <SlOption key={2} value={"2"}>
                Local
              </SlOption>
              <SlOption key={3} value={"3"}>
                Metro
              </SlOption>
              <SlOption key={4} value={"4"}>
                Local-TN
              </SlOption>
            </SlSelect>
          </div>

          <SlInput
            className="w-full"
            size="medium"
            placeholder="Newspaper/Edition/Adv Name "
            onSlInput={debounce(searchFilterOnChange, 500)}
            style={{ width: "230px" }}
          >
            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
          </SlInput>
          <div className="border rounded-lg min-w-fit h-fit">
            <Datepicker
              classNames="form-input "
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              useRange={true} // Allow date range selection
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleDateRange}
            />
          </div>
        </div>
        <img src={filterSvg} alt="filter" onClick={() => setShowFilter(true)} className="w-6 mobileOnly"></img>

      </div>
      <SlDrawer
        label={"Add BirdView"}
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "70vw" }}
      >
        <div className="grid grid-cols-3  gap-3">
          <form
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
            className="col-span-1"
          >
            {/* Date Field */}
            <div className="mb-3">
              <label>Date</label>
              <span className="text-red-600">*</span>
              <input
                type="date"
                className="form-control"
                placeholder="Choose Date"
                {...register("date", { required: "Date is required" })}
              />
              {submit && errors.date && (
                <div className="text-red-600">{errors.date.message}</div>
              )}
            </div>

            {/* Language */}
            <div className="mb-3">
              <label className="form-label">Language</label>
              <Controller
                name="language" // Set the name to "language"
                control={control}
                rules={{ required: "Language is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="language" // Ensure the name is consistent
                    placeholder="Select Language"
                    options={langoptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {submit && errors.language && (
                <div className="text-red-600">{errors.language.message}</div>
              )}
            </div>

            {/* Newspaper Name */}
            <div className="mb-3">
              <label className="mb-1">Newspaper Name</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="newspaper_name"
                // rules={{ required: true }}
                rules={{ required: "Newspaper Name is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="newspaper_name" // Ensure the name is consistent
                    placeholder="Select Newspaper Anme"
                    options={newspapers}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {submit && errors.newspaper_name && (
                <div className="text-red-600">
                  {errors.newspaper_name.message}
                </div>
              )}
            </div>

            {/* Page Number */}
            <div className="mb-3">
              <label className="mb-1">Page Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Page Number"
                {...register("page_no")}
              />
              {submit && errors.page_no && (
                <div className="text-red-600">{errors.page_no.message}</div>
              )}
            </div>

            {/* Edition */}
            <div className="mb-3">
              <label className="form-label">Edition</label>
              <Controller
                name="edition" // Set the name to "edition"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="edition" // Ensure the name is consistent
                    placeholder="Select Edition"
                    options={editions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {submit && errors.edition && (
                <div className="text-red-600">{errors.edition.message}</div>
              )}
            </div>
            {/* Location */}
            {watch("edition")?.value?.toLowerCase().includes("district") && (
              <div>
                <label className="mb-1 mr-2">District</label>
                <Controller
                  control={control}
                  name="location"
                  render={({ field }) => (
                    <Select
                      {...field}
                      name="location" // Ensure the name is consistent
                      placeholder="Select District"
                      options={newspaperLocations}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  )}
                />
                {errors.location && (
                  <div className="text-red-600">{errors.location.message}</div>
                )}
              </div>
            )}

            {/* Ad Format */}
            <div className="mb-3">
              <label className="mb-1">Ad Format</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="ad_format"
                rules={{ required: "Ad Format is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="ad_format" // Ensure the name is consistent
                    placeholder="Select Ad Format"
                    options={AdFormatOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {errors.ad_format && (
                <div className="text-red-600">{errors.ad_format.message}</div>
              )}
            </div>

            {/* Estimated Price */}
            <div className="mb-3">
              <label className="mb-1">Estimated Price</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Estimated Price"
                aria-label="Estimated Price"
                {...register("estimated_value", {
                  required: "Estimated Price is required",
                })}
              />
              {errors.estimated_value && (
                <div className="text-red-600">
                  {errors.estimated_value.message}
                </div>
              )}
            </div>

            {/* Campaign Name Field */}
            <div className="mb-3">
              <label className="mb-1">Campaign Name</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Campaign Name"
                aria-label="Campaign Name"
                {...register("campaign_name", {
                  required: "Campaign Name is required",
                })}
              />
              {errors.campaign_name && (
                <div className="text-red-600">
                  {errors.campaign_name.message}
                </div>
              )}
            </div>

            {/* Brand Type Finite or infinite */}
            <div className="mb-3">
              <label className="mb-1">Brand Type</label>
              <div className="d-flex gap-3">
                <input
                  type="radio"
                  id="finite"
                  {...register("brand_type")}
                  value="finite"
                  defaultChecked
                  onChange={() => {
                    setValue("brand_type", "finite");
                    setValue("brand_name", "");
                  }}
                />
                <label htmlFor="finite">Finite Brands</label>
                <input
                  type="radio"
                  id="vbrand"
                  {...register("brand_type")}
                  value="infinite"
                  onChange={() => {
                    setValue("brand_type", "infinite");
                    setValue("brand_name", "");
                  }}
                />
                <label htmlFor="vbrand">Infinite Brands</label>
              </div>
            </div>

            {/* Brand Name */}
            <div className="mb-3">
              <label className="mb-1">Brand Name</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="brand_name"
                rules={{ required: "Brand Name is required" }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    name="brand_name" // Ensure the name is consistent
                    placeholder="Select Brand Name"
                    defaultOptions={brands}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    loadOptions={debouncedGetBrands}
                    value={defaultValue(brands, getValues("brand_name"))}
                    onChange={(selected) =>
                      setValue("brand_name", selected?.value)
                    }
                  />
                )}
              />
              {errors.brand_name && (
                <div className="text-red-600">{errors.brand_name.message}</div>
              )}
            </div>

            {/* Upload Image */}

            {/* Submit Button */}
            <div className="mb-3 flex gap-3 w-full items-end">
              <button
                type="submit"
                className="btn btn-primary w-1/3 max-h-[40px]"
                onClick={() => setSubmit(true)}
                disabled={isSubmitting || rejectReason.trim().length !== 0}
              >
                Submit
              </button>
              <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Reject Reason" aria-label="Reject Reason" aria-describedby="button-addon2"  onChange={(e) => setRejectReason(e.target.value)}/>
              <button class="btn btn-danger" type="button" id="button-addon2" onClick={onReject} disabled={rejectReason.trim().length === 0}>Reject</button>
            </div>
            </div>
          </form>
          <div className="relative col-span-2 ">
            <img
              src={showOriginal ? originalUrl : imgUrl}
              alt="ad-preview"
              className="rounded-md items-center justify-center flex max-h-[85vh]"
              loading="lazy"
            />
            <div className="absolute top-1 right-1 flex flex-col gap-2 justify-center items-center bg-white px-2 py-1 rounded-md">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="switchUrls"
                  onChange={() => setShowOriginal((prev) => !prev)}
                  checked={showOriginal}
                />
                <label className="form-check-label" htmlFor="switchUrls">
                  Show Paper
                </label>
              </div>
              <div className="form-check form-switch">
                <a
                  className="px-4 py-2 text-blue-600 hover:text-blue-800 font-medium  transition duration-200 ease-in-out"
                  href={showOriginal ? originalUrl : imgUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View In New Tab
                </a>
              </div>
            </div>
          </div>
        </div>
      </SlDrawer>

      {
        // New infinite scrolling
        data?.length && !loader ? (
          <div class="birdviewWrapper">
            <ul class="birdview">
              {data.map((item, index) => {
                  return (
                    <li key={item.id} ref={index === data.length -1 ? lastItemRef : null}>
                      <div class="theme">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="placeholder" />
                        ) : (
                          <img src={NoImage} alt="placeholder" />
                        )}
                        <div class="blur">
                          {" "}
                          {item?.image_url ? (
                            <img src={item.image_url} alt="placeholder" />
                          ) : (
                            <img src={NoImage} alt="placeholder" />
                          )}
                        </div>
                        <div class="publisher">
                          {item?.newspaper_name ? (
                            <h6 style={getColors(item?.newspaper_name)}>
                              {item.newspaper_name}
                            </h6>
                          ) : null}
                          {item?.ad_type === "Local" ? (
                            <h6 class="local">{item.brand_type}</h6>
                          ) : item?.brand_type === "National" ? (
                            <h6 class="national">{item.brand_type}</h6>
                          ) : (
                            <h6 class="districts">{item.brand_type}</h6>
                          )}
                          <h6 className="text-white bg-red-600">Rejected</h6>
                        </div>
                        <p className="location">
                          <img
                            src={LocationSVG}
                            alt="location_name"
                            title={item.location}
                          />
                          {item.location}
                        </p>
                        <p class="estimation">
                          Est Val: <strong>{item.estimated_value || 0}</strong>
                        </p>
                        {item.image_url ? (
                          <Button
                            className="previewBtn"
                            variant="neutral"
                            onClick={() => {
                              setImgSrc(item.image_url);
                              setOpen(true);
                            }}
                          >
                            Preview
                          </Button>
                        ) : null}
                      </div>
                      <div class="description">
                        {item?.page_no ? (
                          <p>
                            Page {item.page_no} : {formatDate(item.date)}
                          </p>
                        ) : (
                          <p>Page - : {formatDate(item.date)}</p>
                        )}
                        <h1>{item.campaign_name || " "}</h1>
                        <h5>Edition : {item.edition || " "}</h5>
                        <h5>Ad Format : {item.ad_format || " "} </h5>
                        <h5>Brand Name : {item.brand_name || " "} </h5>
                        <h5>Reason : {item.reason}</h5>
                      </div>

                      {/* <div class="moreOptions">
                        {localStorage.getItem("role") === roles.b2b ? (
                          <div
                            class="option"
                            onClick={async () => {
                              handleShow("edit", item);
                              setFlag("edit");
                            }}
                          >
                            <img src={EditIcon} alt="" />
                            <h6>Edit</h6>
                          </div>
                        ) : null}
                        <div
                          class="option"
                          onClick={async () => {
                            setAdvDetails(item.advdetails)
                            setPreview(true)
                          }}
                        >
                          <img src={UserIcon} alt="" />
                          <h6>Advertisers</h6>
                        </div>
                      </div> */}
                    </li>
                  );
                
              })}
            </ul>
          </div>
        ) : !data?.length && !loader ? (
          <NoDataFound colspan="17" />
        ) : (
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )
      }
      {infLoader ? (
        <div className="w-full d-flex justify-center items-center">
          <TableLoader />{" "}
        </div>
      ) : null}
      {/* <div className={`flex justify-end stickBottom ${scrolltopdata}`}>
                {totalPages > 1 && (
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage} />)}
            </div> */}

      <SlDrawer
        label={"Advertiser Details"}
        open={preview}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setPreview(false);
          setAdvDetails()
        }}
        style={{ "--size": "70vw" }}
      >
        <div className="flex justify-end mb-5"></div>
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Category</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            {advDetails?.length && !loader ? (
              <tbody>
                {advDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.adv_name || "-"}</td>
                      <td>{item.adv_designation || "-"}</td>
                      <td>{item.adv_email || "-"}</td>
                      <td>{item.adv_category || "-"}</td>
                      <td>{item.adv_phone || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !advDetails?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
      </SlDrawer>

      <Modal
        className="birdview-image-preview"
        show={open}
        onHide={() => setOpen(false)}
      >
        <Modal.Header closeButton>Image Preview</Modal.Header>
        <Modal.Body>
          <img src={imgSrc} alt="" />
        </Modal.Body>
      </Modal>
     
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex gap-4 flex-wrap w-full">
            <div className="w-full">
              <Select
                placeholder="Select Location"
                name="source"
                size="medium"
                value={selectedLocation}
                onChange={(selected) => {
                  setSelectedLocation(selected || []);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[...locations]}
                isMulti
              />
            </div>
            <div className="w-full">
              <Select
                className=""
                placeholder="Select Newspaper"
                name="source"
                size="medium"
                value={selectedNewspaper}
                onChange={(selected) => {
                  setSelectedNewspaper(selected || []);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[
                  ...newspaperData
                    .filter((item) => item.name !== "Way2news")
                    .map((item) => {
                      return { label: item.name, value: item.name };
                    }),
                ]}
                isMulti
              />
            </div>

            <div className="w-full">
              <SlSelect
                className="w-full"
                placeholder="Select Ad Type"
                name="adType"
                size="medium"
                value={adType}
                onSlChange={(e) => {
                  setAdType(e.target.value);
                  setData([]);
                  setCurrentPage(0);
                }}
              >
                <SlOption key={0} value={"Finite"}>
                  Finite
                </SlOption>
                <SlOption key={1} value={"Infinite"}>
                  Infinite
                </SlOption>
              </SlSelect>
            </div>
            <div className="w-full">
              <SlSelect
                placeholder="Select Brand Type"
                name="adType"
                size="medium"
                value={selectedBrandType}
                onSlChange={(e) => {
                  setSelectedBrandType(e.target.value);
                  setData([]);
                  setCurrentPage(0);
                }}
              >
                <SlOption key={0} value={"0"}>
                  All
                </SlOption>
                <SlOption key={1} value={"1"}>
                  National
                </SlOption>
                <SlOption key={2} value={"2"}>
                  Local
                </SlOption>
              </SlSelect>
            </div>

            <SlInput
              className="w-full"
              size="medium"
              placeholder="Newspaper/Edition/Adv Name "
              onSlInput={debounce(searchFilterOnChange, 500)}
            >
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            <div className="border rounded-lg min-w-fit h-fit">
              <Datepicker
                classNames="form-input"
                value={dateRange}
                primaryColor={"cyan"}
                showShortcuts={true}
                useRange={true} // Allow date range selection
                configs={{
                  shortcuts: {
                    today: "today",
                    yesterday: "yesterday",
                    currentMonth: "currentMonth",
                    pastMonth: "lastMonth",
                  },
                }}
                onChange={handleDateRange}
              />
            </div>
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default BirdViewReject;
